module.exports = __webpack_public_path__ + "media/images/lb/271-cd16d73563eb3dd818a08966612a0524.svg";